import React, { FC, useEffect, useState } from 'react';
import { SiPayModal } from 'utilities/components';
import { __CardToCardSelectTargetCardProps } from './selectTargetBankModal.type';
import { detectBank, detectBankByName } from 'scripts';

export const CardToCardSelectTargetCardModal: FC<__CardToCardSelectTargetCardProps> = (
    props: __CardToCardSelectTargetCardProps,
) => {
    const [isOpen, setIsOpen] = useState<boolean>(props.isOpen);

    useEffect(() => {
        setIsOpen(props.isOpen);
    }, [props.isOpen]);

    return (
        <SiPayModal isOpen={isOpen} onClose={props.onClose} title="انتخاب بانک مقصد">
            <div style={{ direction: 'ltr' }} className="max-h-[350px] overflow-auto">
                <div style={{ direction: 'rtl' }}>
                    {props.data ? (
                        props.data.map((item, index) => (
                            <div
                                key={index}
                                onClick={() => {
                                    props.onSelect(item);
                                    props.onClose();
                                }}
                                className={
                                    'flex gap-4 items-center rounded-[28px] text-base px-6 h-14 max-lg:h-12 max-lg:text-sm mt-2 clickable hover:bg-[#F1F8FF80] !transition-all'
                                }
                            >
                                <div className={'flex items-center gap-4'}>
                                    <img src={detectBankByName(item?.bankName)?.bank_logo} className={'w-6 h-6'} />
                                </div>
                                <p className="text-base font-bold text-darkPurple-100 flex-1">
                                    حساب بانکی سی پی - {item.bankName}
                                </p>
                            </div>
                        ))
                    ) : (
                        <p className="text-gray-500 my-4 text-center">داده‌ای جهت نمایش وجود ندارد</p>
                    )}
                </div>
            </div>
        </SiPayModal>
    );
};
